import { createApp } from 'vue'
import ElementPlus from 'element-plus'
import zhCn from 'element-plus/dist/locale/zh-cn.mjs'
import 'element-plus/dist/index.css'
import './assets/tailwind.css'
import App from './App.vue'
import router from './router'
import { createPinia } from 'pinia'
import { setupDirectives } from './directives'

const app = createApp(App)

app.use(ElementPlus, { locale: zhCn })
app.use(router)
app.use(createPinia())

// 注册自定义指令
setupDirectives(app)

app.mount('#app')
